const formatCategory = (category) => {
  return Array.isArray(category?.breadcrumbs?.edges)
    ? category?.breadcrumbs.edges
        ?.map((item) => {
          return item?.node?.name;
        })
        .filter(Boolean)
        .join('/')
    : null;
};

export const convertToGa4Item = ({
  product = null,
  variant = null,
  quantity = 1,
  ...rest
}) => {
  const id = variant?.sku || product?.sku || '';

  const categories = product?.categories?.edges;

  const item_category = formatCategory(categories?.[0]?.node) || '';
  const item_category2 = formatCategory(categories?.[1]?.node) || '';
  const item_category3 = formatCategory(categories?.[2]?.node) || '';
  const item_category4 = formatCategory(categories?.[3]?.node) || '';

  const price =
    variant?.prices?.price?.value || product?.prices?.price?.value || '';

  const currency =
    variant?.prices?.price?.currencyCode ||
    product?.prices?.price?.currencyCode ||
    'EUR';

  return {
    item_name: product?.name,
    item_id: id,
    item_variant: id,
    item_brand: product?.brand || '',
    item_category,
    item_category2,
    item_category3,
    item_category4,
    price,
    currency,
    quantity,
    ...rest,
  };
};
